
import { Component, Vue, Prop, namespace } from 'nuxt-property-decorator';
import { PostFormEntryResultDto, EventDto, generateUserFriendlyId } from 'fourwaves-shared';
import { ActionSpinner } from 'fourwaves-shared/components';

const EventsModule = namespace('events');

@Component({
  components: {
    ActionSpinner,
  },
})
export default class ConfirmationPanel extends Vue {
  @Prop() serviceResult!: PostFormEntryResultDto | null;
  @EventsModule.Getter isParticipant!: boolean;
  @EventsModule.Getter isOrganizer!: boolean;

  @EventsModule.State currentEvent!: EventDto;

  get canDownload() {
    return this.isParticipant || this.isOrganizer;
  }

  public async downloadPDF() {
    if (!this.serviceResult || !this.serviceResult.transactionId) return;

    this.$wait.start('download');
    await this.$api.downloadPdfReceiptById(this.serviceResult.transactionId);
    this.$wait.end('download');
  }

  public getUserFriendlyId(id: string): string {
    return generateUserFriendlyId(id);
  }
}
